import * as React from "react";
import {
  CustomerNotification as InlineNotification,
  CustomerNotificationLocation as InlineNotificationLocation,
} from "@shared-ui/customer-notifications";
import { PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

interface TravelAdvisoryProps {
  context: ExtendedContextStore;
  page?: PageStore;
}

export const TravelAdvisory: React.FC<TravelAdvisoryProps> = inject("page")((props: TravelAdvisoryProps) => {
  const { context, page } = props;
  const isTravelAdvisoryExperimentEnabled = isVariantEnabled(
    context,
    Experiment.LP_SC_Covid19_TravelAdvisory_for_LandingPages
  );

  if (!page || !page.pageId || !context || !isTravelAdvisoryExperimentEnabled) {
    return null;
  }

  let regionId = context.searchContext?.location?.id?.toString() || "";

  if (context.searchContext?.location?.type === "hotel") {
    regionId = context.searchContext?.location?.parent.id?.toString() || "";
  }

  return (
    <div className="travelAdvisoryBanner uitk-cell all-cell-1-1 all-y-padding-three">
      <InlineNotification
        inputs={{
          xPageId: page.pageId,
          notificationLocation: InlineNotificationLocation.AFTER_HEADER,
          optionalContext: {
            journeyCriterias: [
              {
                destination: {
                  regionId: regionId,
                },
              },
            ],
          },
        }}
      />
    </div>
  );
});

export default TravelAdvisory;
